The candidate's email address.
